import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

import { Core } from "@grapecity/activereports";
Core.setLicenseKey("E537567536522139#B0zjv5xUbEF5KSV5S8tEaJdTcIZHekh4VzUFcQdERIlFaRNEVZ3ySaN7NnFkQGREU43Gcidzaop6aQ5kQSlkc5g6TKdmVzEzVvl6ZCR6aXxUa5BFSBRUT4okb4VWTxZlT79EZSVmZzNFSJhDMjNkUrl6QyskWCZTMOtCd7FDdIRTVzMnTFRTe6VVcDdlSVNUZNlkNUBHcX5WaEZWWkNlUaN5VahGSEV6MJJ6ZKZWW7gGR7lVewxkT9wmdotSQv3GMvFTWkRlWal5cz9EetZ5TGp5UKZHNCtiT6pFcwdXNYF6NGtkYTp5MSlnSYRzazR4MWd4Y4IlI0IyUiwiIyIjQ5UDREJjI0ICSiwCNxUTOxUDO5kTM0IicfJye&Qf35Vfi24QRpkI0IyQiwiIzYFITpEdy3GclJVZ6lGdjFkI0IiTis7W0ICZyBlIsICO5EzMyEDIxITNwIjMwIjI0ICdyNkIsIyNxMDMzIDMyIiOiAHeFJCLiY7btV7ahJWQgkXZnJXZTJiOiEmTDJCLlVnc4pjIsZXRiwiI9MTMyITN6MTN7YTN7MTNiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TQSpVRFBnUH9Gal56MrVVNaxkZy3kMGJXW64kd7Q7ZZFkYlhTZJ9GUjVXeBtCNZFnNy2kcSJlbaRDSCVWbxcUOlNnSslEOz9WTNhESP3UVSh5UhJWeyMnYtNlUatiThBUfP");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
